var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"xl":16,"lg":20}},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"always"}},[_c('div',{attrs:{"id":"igv-div"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }